import { ethers } from "ethers";
import ERC20ABI from "../abi/ERC20ABI.json";
import { useAtom } from "jotai";
import { tokenContractAddress } from "../stateManagement/tokenAddressAtom";

export const useHoldersBalance = () => {
  
  const callHolderBalance = async (
    provider: ethers.ContractRunner | null | undefined,
    customerID: any | ethers.Overrides,
    tokenAddress: string | null 
  ) => {
    try {
      const tokenContract = new ethers.Contract(
        tokenAddress || "",
        ERC20ABI.abi,
        provider
      );

      const res = await tokenContract.getHolderBalance(customerID);
      return res;
    } catch (error) { }
  };

  return {
    onCheckBalanceHolder: callHolderBalance,
  };
};
